import axiosInstance from './axiosInstance';
import { variables } from './variables';

const API_URL = variables.ADMIN_API; // https://localhost:7278/api/Admin

const customerApi = {
  getCustomersDetails: async (params = { pageNumber: 1, pageSize: 100 }) => {
    // Map params to match API expectations
    const mappedParams = {
      SortColumn: params.sortColumn || 'customerDisplay',
      SortOrder: params.sortOrder || 'asc',
      SearchTerm: params.SearchTerm || '',
      Page: params.page || 1,
      PageSize: params.pageSize || 50,
    };
    const response = await axiosInstance.get(`${API_URL}/GetCustomerSwitcherList`, { params: mappedParams });
    return response.data;
  }
};

export default customerApi;